import { render, staticRenderFns } from "./SystemIcon.vue?vue&type=template&id=835a0428&"
import script from "./SystemIcon.vue?vue&type=script&lang=js&"
export * from "./SystemIcon.vue?vue&type=script&lang=js&"
import style0 from "./SystemIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports